// extracted by mini-css-extract-plugin
export var filterIncDec = "_b7-0";
export var leftBorder = "_b7-1";
export var rightBorder = "_b7-2";
export var stringInput = "_b7-3";